var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 381.875 381.875",
    style: {
      enableBackground: "new 0 0 381.875 381.875"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9bc9ff"
    },
    d: "M278.656 152.664V24.388c-35.365 0-64.138 28.772-64.138 64.138s28.773 64.138 64.138 64.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57a4ff"
    },
    d: "M342.794 88.526c0-35.365-28.772-64.138-64.138-64.138v128.275c35.366.001 64.138-28.772 64.138-64.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9bc9ff"
    },
    d: "M278.656 167.664c-28.921 0-56.125 12.686-74.853 33.757 24.061 21.269 39.6 51.962 40.783 86.243h134.069v-20c.001-55.141-44.858-100-99.999-100z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2488ff"
    },
    cx: 270.939,
    cy: 361.875,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2488ff"
    },
    cx: 110.939,
    cy: 361.875,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2488ff"
    },
    cx: 190.939,
    cy: 361.875,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003f8a"
    },
    d: "M203.804 201.42c-21.297-18.825-49.262-30.27-79.855-30.27v140.73h120.72v-20c0-1.412-.033-2.816-.082-4.216-1.183-34.282-16.722-64.975-40.783-86.244zm-4.285-125.84c0-41.67-33.9-75.58-75.57-75.58v151.15c41.67 0 75.57-33.9 75.57-75.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005ece"
    },
    d: "M3.219 291.88v20h120.73V171.15c-66.57 0-120.73 54.16-120.73 120.73zm120.73-140.73V0c-41.67 0-75.58 33.91-75.58 75.58s33.91 75.57 75.58 75.57z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8f7c3f829dc8d06ad6624f87bd4ded20.svg";
export { ForwardRef as ReactComponent };